import React from 'react';

import {LazyTooltip} from 'app/components/general/LazyTooltip';
import {gt} from 'app/utils/i18n';

export function SafeAIStatement() {
  return (
    <LazyTooltip
      tooltip={gt(
        "SweetAI uses trusted AI. Your data is safe, serves your request only, and isn't used for training."
      )}
    >
      <i className="text-muted ml-1 far fa-info-circle" aria-hidden="true" />
    </LazyTooltip>
  );
}
